import { Popconfirm } from "antd";
import { useState } from "react";
import { toast } from "react-toastify";

import { RoundedButton } from "@/components";
import { DownloadIcon, TrashCanIcon } from "@/components/icon";
import useDeleteDocument from "@/common/api/mutation/documentsMutations/useDeleteDocument.mutation";
import { queryClient } from "@/common/utils";
import { usePermissions } from "@/common/contexts/Permissions.context";

export default function DocumentElementActions({ data }: { data: any }) {
  const [isConfirmOpened, setIsConfirmOpened] = useState(false);
  const { mutate } = useDeleteDocument();
  const { isHavePermission } = usePermissions();

  const openConfirm = () => {
    setIsConfirmOpened(true);
  };

  const handleDownloadDocument = async (fileUrl: string) => {
    if (!data) {
      toast.error("Something went wrong");
      return;
    }

    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", "");
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  const deleteDocument = () => {
    mutate(data.id, {
      onSuccess: () => {
        queryClient.invalidateQueries();
        setIsConfirmOpened(false);
        toast.success("Price element was deleted successfully");
      },
    });
  };

  return (
    <div className="flex gap-2">
      <RoundedButton
        func={() => handleDownloadDocument(data.file)}
        icon={<DownloadIcon />}
        className="bg-blue-light text-primary"
        key={"blue" + data.id}
      />
      {isHavePermission("documents_delete") && (
        <Popconfirm
          title="Delete this document"
          placement="rightTop"
          description="Are you sure you want to delete document?"
          onConfirm={deleteDocument}
          trigger="click"
          okText="Yes"
          cancelText="No"
          open={isConfirmOpened}
          onCancel={() => setIsConfirmOpened(false)}
        >
          <RoundedButton
            func={openConfirm}
            className="bg-red-light text-red-main"
            icon={<TrashCanIcon />}
            key={"red" + data.id}
          />
        </Popconfirm>
      )}
    </div>
  );
}
